import kpi from './kpi';
import auth from './auth';
import tools from './tools';
import strapi from './strapi';
import search from './search';
import profile from './profile';
import tierratv from './tierratv';
import newsLetter from './newsLetter';
import { defineStore } from 'pinia';

const storeCombiner = (...stores) => {
  function mapper(suffix, source) {
    return Object.values(source).reduce((acc, curr) => {
      acc[`${suffix}/${curr.name}`] = curr;
      return acc;
    }, {});
  }
  const combined = stores.reduce(
    (acc, store) => {
      if (store.state) Object.assign(acc.state, store.state());
      if (store.getters) {
        const existingGetters = acc.getters.getters();
        const currentGetters = mapper(store.suffix, store.getters.getters());
        acc.getters = { getters: () => Object.assign({}, existingGetters, currentGetters) };
      }
      if (store.actions) Object.assign(acc.actions, mapper(store.suffix, store.actions));
      if (store.mutations) Object.assign(acc.mutations, mapper(store.suffix, store.mutations));
      return acc;
    },
    {
      state: {},
      actions: {},
      mutations: {},
      getters: { getters: () => ({}) }
    }
  );

  const actions = {
    commit: (func, args1) => {
      const state = useStore();
      const mutation = combined.mutations[func];
      if (mutation) return mutation(state, args1);
    },
    dispatch: (func, args1) => {
      const state = useStore();
      const {
        $i18n: { locale },
        $router: { currentRoute }
      } = useNuxtApp();
      const customLocale = currentRoute.value.path.includes(STARTUPS_BASE_URL)
        ? locale
        : { locale: { value: process.env.APP_LOCALE || 'es' } };
      const action = combined.actions[func];
      if (action) return action({ state, locale: customLocale, commit: actions.commit }, args1);
    }
  };

  return {
    actions,
    getters: combined.getters,
    state: () => combined.state
  };
};

const modules = storeCombiner(kpi, auth, tools, strapi, search, profile, tierratv, newsLetter);

export const useStore = defineStore('store', modules);
